import { type FC } from 'react';
import { Container, TitleBlock } from '../primitives';

/**
 * Native details/summary accordion: works in prerendered HTML before any
 * JavaScript loads, which also means crawlers see every answer.
 */
export const Faq: FC<{
  faqs: ReadonlyArray<{ question: string; answer: string }>;
  sheet?: string;
  title?: string;
}> = ({ faqs, sheet = 'DB-04 - Straight answers', title = 'Common questions' }) => (
  <section className="border-t border-ink-200 bg-white py-20 sm:py-28">
    <Container className="max-w-3xl">
      <TitleBlock sheet={sheet} title={title} />
      <div className="divide-y divide-ink-200 border-y border-ink-200">
        {faqs.map((faq) => (
          <details key={faq.question} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left font-semibold text-ink-900 [&::-webkit-details-marker]:hidden">
              {faq.question}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                aria-hidden="true"
                className="flex-shrink-0 text-brand-600 transition-transform duration-200 group-open:rotate-45"
              >
                <path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </summary>
            <p className="mt-3 pr-8 text-sm leading-relaxed text-ink-600">{faq.answer}</p>
          </details>
        ))}
      </div>
    </Container>
  </section>
);
